interface ICard {
  title: string;
  desc?: string;
  cards: ICard[];
}

interface IData {
  title: string;
  cards: ICard[];
}

export default function SectionOffer({ data }: { data: IData }) {
  const { title, cards } = data;
  return (
    <section className="bg-[#2D2659] mt-20 py-20 text-white text-xl">
      <div className="max-w-[1000px] px-4 mx-auto">
        <h2 className="text-white text-4xl max-md:text-xl">{title}</h2>
        <div>
          {cards.map((item: ICard, index: number) => (
            <div className="mt-10 leading-8 max-md:text-sm" key={index}>
              <h3 className="text-white font-semibold">{item.title}</h3>
              {item.desc && <div className="mt-2">{item.desc}</div>}
              {item.cards && (
                <div className="mt-2">
                  {item.cards.map((subItem: ICard, subIndex: number) => (
                    <div key={subIndex}>{subItem.title}</div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
